import React, { Component } from "react";
import { Divider, Flag, Icon } from "semantic-ui-react";

class Footer extends Component {
  render() {
    return (
      <div>
        <Divider hidden section />
        <p className="footer"></p>
        <p className="credits">
          Made with &nbsp;
          <Icon size="small" color="red" name="heart" />
          from &nbsp;
          <Flag name="ph" />
        </p>
        <Divider hidden section />
      </div>
    );
  }
}

export default Footer;
